import { render } from "./AnnotaionRequestsTableRecord.vue?vue&type=template&id=6560b0c0&scoped=true"
import script from "./AnnotaionRequestsTableRecord.vue?vue&type=script&lang=js"
export * from "./AnnotaionRequestsTableRecord.vue?vue&type=script&lang=js"

import "./AnnotaionRequestsTableRecord.vue?vue&type=style&index=0&id=6560b0c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6560b0c0"]])

export default __exports__